export default __webpack_public_path__ + "static/media/bhi-digital-dashboard.f84073a9.jpg";